<script lang="ts" setup>
import ModalBalanceHistory from '~/components/Modal/ModalBalanceHistory.vue'
import ModalBalanceDeposit from '~/components/Modal/ModalBalanceDeposit.vue'
import toPrice from '~/utils/toPrice'
import { useIdentity } from '~/store/identity'
import Button from '~/components/Button.vue'

const { t } = useLang()
const identity = useIdentity()
const { isAlt } = useTheme()
const user = await identity.getUser()
const isModalBalanceHistoryVisible = ref(false)
const isModalBalanceDepositVisible = ref(false)
const userBalance = computed(() => toPrice(user?.balance ?? 0))

function openBalanceHistoryModal() {
  isModalBalanceDepositVisible.value = false
  isModalBalanceHistoryVisible.value = true
}
function openBalanceDepositModal() {
  isModalBalanceHistoryVisible.value = false
  isModalBalanceDepositVisible.value = true
}
</script>

<template>
  <div class="sidebar-balance">
    <span class="balance-wrap">
      <span class="text-text2 dark:text-dmText2 alt:text-text1 dark:alt:text-dmText1">
        <span v-text="isAlt ? t('balance.your_balance') : t('balance.your_site_balance')" />:
      </span>
      <span class="text-text1 dark:text-dmText1 price">{{ userBalance }}</span>
    </span>
    <div class="flex flex-row gap-x-2 mt-4">
      <Button class="w-1/2" @click="openBalanceDepositModal">
        <span class="text-sm">{{ t('balance.deposit') }}</span>
      </Button>
      <Button button-type="trinary" class="w-1/2" @click="openBalanceHistoryModal">
        <span class="text-sm">{{ t('balance.balance_history') }}</span>
      </Button>
    </div>
    <ModalBalanceHistory
      :visible="isModalBalanceHistoryVisible"
      @handle="(value) => (isModalBalanceHistoryVisible = value)"
      @deposit="openBalanceDepositModal" />

    <ModalBalanceDeposit
      :visible="isModalBalanceDepositVisible"
      @handle="(value) => (isModalBalanceDepositVisible = value)" />
  </div>
</template>

<style lang="postcss" scoped>
.sidebar-balance {
  @apply p-5 mb-8 bg-neutral8 dark:bg-dmGray1;
  border-radius: theme('vars.borderRadiusHeavy');
}
</style>

<style lang="postcss" scoped>
.alt .balance-wrap {
  @apply font-bold;
}
</style>

<style lang="postcss" scoped>
.wl .balance-wrap {
  @apply font-normal flex justify-between;

  .price {
    @apply font-semibold;
  }
}
</style>
